import { boot } from 'quasar/wrappers';
import axios from 'axios';
import { Notify, Cookies } from 'quasar';
import { titlefy } from '@/utils/string';

const api = axios.create({
    baseURL: '/',
    headers: {
        'X-CSRFToken': Cookies.get('csrftoken'),
        'X-Requested-With': 'axios',
    },
});

api.interceptors.response.use(
    (response) => {
        const message = response.data?.detail || response.data?.message;
        if (message) {
            Notify.create({
                type: 'positive',
                message,
            });
        }
        return response;
    },
    async (error) => {
        if (
            (error.response && (error.response.status > 400))
            || (!error.response.config.ignore400 && error.response.status === 400)
        ) {
            let responseData = error.response.data;
            if (error.response.request.responseType === 'blob' && responseData instanceof Blob && responseData.type) {
                const text = await responseData.text();
                responseData = responseData.type.toLowerCase().includes('json') ? JSON.parse(text) : text;
            }

            let messages = [];
            const singleMessage = responseData?.detail || responseData?.error;
            if (singleMessage) messages.push(singleMessage);
            if (messages.length === 0 && error.response.status === 404) {
                messages = ['Requested resource not found'];
            } else if (typeof responseData === 'object' && Object.keys(responseData).length > 0) {
                Object.entries(responseData).forEach(([key, value]) => {
                    messages.push(`${titlefy(key)}: ${value}`);
                });
            } else {
                messages = ['There was an unexpected error. Please, try again later.'];
            }
            messages.forEach((message) => {
                Notify.create({
                    type: 'negative',
                    message,
                });
            });
        }
        return error?.response || {};
    },
);

export default boot(({ app }) => {
    // for use inside Vue files (Options API) through this.$axios and this.$api
    app.config.globalProperties.$axios = axios;
    app.config.globalProperties.$api = api;
});

export { api };
